var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersColBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6007 17.2831V15.4426C15.6007 14.4664 15.2129 13.5301 14.5226 12.8398C13.8322 12.1495 12.896 11.7617 11.9197 11.7617H4.55788C3.58164 11.7617 2.64538 12.1495 1.95507 12.8398C1.26476 13.5301 0.876953 14.4664 0.876953 15.4426V17.2831",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23952 8.08061C10.2724 8.08061 11.9205 6.4326 11.9205 4.39968C11.9205 2.36676 10.2724 0.71875 8.23952 0.71875C6.2066 0.71875 4.55859 2.36676 4.55859 4.39968C4.55859 6.4326 6.2066 8.08061 8.23952 8.08061Z",
    fill: "#1B90FE",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.122 17.2826V15.4422C21.1214 14.6266 20.85 13.8343 20.3503 13.1897C19.8506 12.5451 19.151 12.0848 18.3613 11.8809",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 0.839844C15.4715 1.04257 16.1733 1.50306 16.6744 2.1487C17.1756 2.79434 17.4476 3.58842 17.4476 4.40575C17.4476 5.22307 17.1756 6.01715 16.6744 6.66279C16.1733 7.30843 15.4715 7.76892 14.6797 7.97165",
    stroke: "#1B90FE",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersColBlue);
export default __webpack_public_path__ + "static/media/users_col_blue.7870980bfe56c122c7ebc4325fc545e8.svg";
export { ForwardRef as ReactComponent };